// utils/strings.ts
export function createSlug(texto: string): string {
  return texto
    .toString()
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-');
}

export function convertArrayToStringFormated(itens: string[]): string {
  // Configura o formatador para Português do Brasil com o estilo de conjunção ("e")
  const formatador = new Intl.ListFormat('pt-BR', {
    style: 'long',
    type: 'conjunction'
  });

  return formatador.format(itens);
}

export function clearTagsHTML(html: string | undefined): string | undefined {
  if (!html) return undefined;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

export function capitalizeFirstLetter(texto: string | undefined): string | undefined {
  if (!texto) return '';

  const textoLimpo = texto.trim();

  if (textoLimpo.length === 0) return '';

  return textoLimpo.charAt(0).toUpperCase() + textoLimpo.slice(1);
}

export function clearTagsAndCapitFirst(html: string | undefined): string | undefined {
  return capitalizeFirstLetter(clearTagsHTML(html))
}